export default __webpack_public_path__ + "assets/Lato-BlackItalic.09fc285661e54addb1fd7ace8731d173.ttf";